module.exports = __webpack_public_path__ + "bbf82b0f8d20f2f77d39d2f8007d97f3.svg";